import styled from 'styled-components';
import { HiddenInput, StyledLabel } from '../checkbox/styled';
import { getSizeBy, getColorShade, getColor } from '../../../src/styled/utils';
export const Slider = styled.span `
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  width: ${getSizeBy(9.5)};
  height: ${getSizeBy(5)};
  background-color: ${getColorShade('onSurface', 'lowEmphasis')};
  border-radius: ${getSizeBy(20.75)};
  cursor: pointer;
  transition: background-color 200ms;

  &::before {
    position: relative;
    left: ${getSizeBy(0.5)};
    width: ${getSizeBy(4)};
    height: ${getSizeBy(4)};
    background-color: ${getColorShade('onPrimary', 'mediumEmphasis')};
    border-radius: 50%;
    transition-duration: 200ms;
    transition-property: transform, background-color;
    content: '';
  }

  ${HiddenInput}:checked + &::before {
    transform: translateX(${getSizeBy(4.5)});
  }

  ${HiddenInput}:not(:disabled):focus + &::before {
    background-color: ${getColorShade('onPrimary', 'lowEmphasis')};
  }

  ${HiddenInput}:disabled + & {
    background-color: ${getColorShade('onSurface', 'outline')};
    cursor: not-allowed;
  }

  ${HiddenInput}:checked:not(:disabled) + & {
    background-color: ${getColor('primary')};
  }
`;
export const StyledLabelToggle = styled(StyledLabel) `
  &:hover > ${HiddenInput}:not(:disabled) + ${Slider}::before {
    background-color: ${getColorShade('onPrimary', 'highEmphasis')};
  }
`;
